import { render, staticRenderFns } from "./hrd-register-trainee.vue?vue&type=template&id=674a3ab0&scoped=true"
import script from "./hrd-register-trainee.vue?vue&type=script&lang=js"
export * from "./hrd-register-trainee.vue?vue&type=script&lang=js"
import style0 from "./hrd-register-trainee.vue?vue&type=style&index=0&id=674a3ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a3ab0",
  null
  
)

export default component.exports